import { subMonths } from 'date-fns';
import { Subscription } from 'src/types/user';

export const getYearPeriodsBySubscription = (subscription: Subscription) => {
  const period = subscription?.plan?.availableDataPeriod ?? 0;
  const years: number[] = [];

  const startYear = new Date().getFullYear();
  const endYear = subMonths(new Date(), period).getFullYear();

  for (let year = startYear; year >= endYear; year--) {
    years.push(year);
  }

  return years;
};
